module.exports = __webpack_public_path__ + "img/ggads.6a6e639b.svg";